import 'datatables';
import 'bootstrap-table';
require ("bootstrap-table/dist/locale/bootstrap-table-ru-RU.min.js");

/**
 * @author: Dennis Hernández
 * @webSite: http://djhvscf.github.io/Blog
 * @version: v1.0.0
 */

!function ($) {

    'use strict';

    var getFieldIndex = function (columns, field) {
        var index = -1;

        $.each(columns, function (i, column) {
            if (column.field === field) {
                index = i;
                return false;
            }
            return true;
        });
        return index;
    };

    var calculateObjectValue = function (self, name, args, defaultValue) {
        var func = name;

        if (typeof name === 'string') {
            // support obj.func1.func2
            var names = name.split('.');

            if (names.length > 1) {
                func = window;
                $.each(names, function (i, f) {
                    func = func[f];
                });
            } else {
                func = window[name];
            }
        }
        if (typeof func === 'object') {
            return func;
        }
        if (typeof func === 'function') {
            return func.apply(self, args);
        }
        if (!func && typeof name === 'string' && sprintf.apply(this, [name].concat(args))) {
            return sprintf.apply(this, [name].concat(args));
        }
        return defaultValue;
    };

    $.extend($.fn.bootstrapTable.defaults, {
        multipleSearch: false
    });

    var BootstrapTable = $.fn.bootstrapTable.Constructor,
        _initSearch = BootstrapTable.prototype.initSearch;

    BootstrapTable.prototype.initSearch = function () {

        if (this.options.multipleSearch) {
            var strArray = this.searchText.split(" "),
                that = this,
                f = $.isEmptyObject(this.filterColumns) ? null : this.filterColumns,
                dataFiltered = [];

            if (strArray.length === 0) {
                _initSearch.apply(this, Array.prototype.slice.apply(arguments));
            } else {

                /*this.data = f ? $.grep(this.options.data, function (item, i) {
                    for (var key in f) {
                        if (item[key] !== f[key]) {
                            return false;
                        }
                    }
                    return true;
                }) : this.options.data;*/

                for (var i = 0; i < strArray.length; i++) {
                    var str = strArray[i].trim();
                    dataFiltered = str ? $.grep(dataFiltered.length === 0 ? this.options.data : dataFiltered, function (item, i) {
                        for (var key in item) {
                            key = $.isNumeric(key) ? parseInt(key, 10) : key;
                            var value = item[key],
                                column = that.columns[getFieldIndex(that.columns, key)],
                                j = $.inArray(key, that.header.fields);

                            // Fix #142: search use formated data
                            if (column && column.searchFormatter) {
                                value = calculateObjectValue(column,
                                    that.header.formatters[j], [value, item, i], value);
                            }

                            var index = $.inArray(key, that.header.fields);
                            if (index !== -1 && that.header.searchables[index] && (typeof value === 'string' || typeof value === 'number')) {
                                if (that.options.strictSearch) {
                                    if ((value + '').toLowerCase() === str) {
                                        return true;
                                    }
                                } else {
                                    if ((value + '').toLowerCase().indexOf(str) !== -1) {
                                        return true;
                                    }
                                }
                            }
                        }
                        return false;
                    }) : this.data;
                }

                this.data = dataFiltered;
            }
        } else {
            _initSearch.apply(this, Array.prototype.slice.apply(arguments));
        }
    };

}(jQuery);




export default (function () {
    
    $('[data-toggle="table"]').bootstrapTable({
        pagination:true,
        search:true,
        paginationLoop:false
    });

    $('#teamTable').bootstrapTable({
        url: $('#teamTable').data('url'),
        pagination:true,
        search:true,
        multipleSearch:true,
        strictSearch:false,
        paginationLoop:false
    });

    $('#search-form').on('submit', function(e) {
        e.preventDefault();
        $('#teamTable').bootstrapTable('refreshOptions',{searchText:$('input[name=q]').val().toLowerCase()+' '+$('select[name=city]').val().toLowerCase()});
    });


    
  $('#dataTable').DataTable({
      "scrollX": true,
      "language": {
          "url": "//cdn.datatables.net/plug-ins/1.10.19/i18n/Russian.json"
      }
  });

  var teamsTable = $('#teamsTable').DataTable({
        scrollX: true,
        language: {
            url: "//cdn.datatables.net/plug-ins/1.10.19/i18n/Russian.json"
        },
        processing: true,
        order: [[ 2, 'desc' ]],
        searching: true,
    });
    

  if($('#teams-table2').length){
    var table = $('#teams-table').DataTable({
        language: {
            "url": "//cdn.datatables.net/plug-ins/1.10.19/i18n/Russian.json"
        },
        processing: true,
        serverSide: true,
        searching: false,
        scrollX: 1,
        ajax: {
            url:$('#teams-table').data('url'),
            data: function (d) {
                d.q = $('input[name=q]').val();
                d.city = $('select[name=city]').val();
            }
        },
        
        columns: [
            { data: 'name', name: 'name' },
            { data: 'city', name: 'city' },
            { data: 'sum', name: 'sum' },
            // { data: 'round1_smm', name: 'round1_smm' },
            // { data: 'round2_smm', name: 'round2_smm' },
            // { data: 'round2_all', name: 'round2_all' },
            // { data: 'round3_smm', name: 'round3_smm' },
            // { data: 'round3_all', name: 'round3_all' },
            // { data: 'round4_smm', name: 'round4_smm' },
            // { data: 'round4_all', name: 'round4_all' },
            { data: 'action', name: 'action', orderable: false, searchable: false },
        ],
        order: [[ 0, 'desc' ]]
    });

    // $('#search-form').on('submit', function(e) {
    //     table.draw();
    //     e.preventDefault();
    // });
  }




  if($('.ticket-table').length){

    $('.ticket-table').bootstrapTable({
        url: $('#ticket-table').data('url'),
        pagination: true,
        search: true,
        sidePagination:'server',
        paginationLoop:false,
        columns: [
            { field: 'subject'},
            { field: 'category'},
            { field: 'status'},
            { field: 'agent'},
            { field: 'last_update'},
            { field: 'action'},
        ],
      })


    // var table = $('.ticket-table').DataTable({
    //     language: {
    //         "url": "//cdn.datatables.net/plug-ins/1.10.19/i18n/Russian.json"
    //     },
    //     processing: true,
    //     serverSide: true,
    //     //searching: false,
    //     scrollX: 1,
    //     ajax: {
    //         url:$('#ticket-table').data('url'),
    //     },
        
    //     columns: [
    //         { data: 'subject', name: 'subject', orderable: false },
    //         { data: 'category', name: 'category', orderable: false },
    //         { data: 'status', name: 'status', orderable: false },
    //         { data: 'agent', name: 'agent', orderable: false },
    //         { data: 'last_update', name: 'last_update', orderable: false},
    //         { data: 'action', name: 'action', orderable: false, searchable: false },
    //     ],
    // });

    // $('#search-form').on('submit', function(e) {
    //     table.draw();
    //     e.preventDefault();
    // });
  }

}());
